module.exports = __webpack_public_path__ + "img/Article-image16.e0102974.jpg";